import { Button, Modal, Space, InputNumber } from "antd";
import React, { useState } from "react";
import { EditFilled } from "@ant-design/icons";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "../../../firebase/config";
import { Notification } from "../../Notification";

const initialState = null;

export const MachinesPopup = (props) => {
   const [isModalOpen, setIsModalOpen] = useState(initialState);
   const [speed, setSpeed] = useState(initialState);
   const [electricity, setElectricity] = useState(initialState);
   const [worker, setWorker] = useState(initialState);
   const [amortization, setAmortization] = useState(initialState);
   const [alsm, setAlsm] = useState(initialState);
   const [stations, setStations] = useState(initialState);

   const showModal = async () => {
      setIsModalOpen(true);
      setSpeed(props.speed);
      setElectricity(props.costs.electricity);
      setWorker(props.costs.worker);
      setAmortization(props.costs.amortization);
      setAlsm(props.alsm);
      setStations(props.stations);
   };

   const handleCancel = () => {
      setIsModalOpen(false);
      setSpeed(initialState);
      setElectricity(initialState);
      setWorker(initialState);
      setAmortization(initialState);
      setAlsm(initialState);
      setStations(initialState);
   };

   const updateData = async (e) => {
      e.preventDefault();
      const ref = doc(db, "machines", props.id);
      await updateDoc(ref, {
         speed: speed,
         costs: {
            worker: worker,
            amortization: amortization,
            electricity: electricity,
         },
         alsm: alsm,
         stations: stations,
         id: props.id,
      })
         .then(() => {
            setIsModalOpen(true);
            setSpeed(initialState);
            setElectricity(initialState);
            setWorker(initialState);
            setAmortization(initialState);
            setAlsm(initialState);
            setStations(initialState);
            Notification("success", "Updated!", "Your data has been updated");
         })
         .then(() => {
            setIsModalOpen(false);
         })
         .catch((err) => {
            Notification("error", "Login Error", err.message);
         });
   };
   return (
      <>
         <Button size="small" type="primary" onClick={showModal}>
            <EditFilled />
         </Button>
         <Modal width={1000} title={props.title} open={isModalOpen} onOk={updateData} onCancel={handleCancel}>
            <Space>
               <InputNumber addonBefore="Electricity :" value={electricity} style={{ width: "100%" }} onChange={(value) => setElectricity(value)} />
               <InputNumber addonBefore="Worker :" value={worker} style={{ width: "100%" }} onChange={(value) => setWorker(value)} />
               <InputNumber addonBefore="Amortization :" value={amortization} style={{ width: "100%" }} onChange={(value) => setAmortization(value)} />
               <InputNumber addonBefore="Speed :" value={speed} style={{ width: "100%" }} onChange={(value) => setSpeed(value)} />
               <InputNumber addonBefore="ALSM :" value={alsm} style={{ width: "100%" }} onChange={(value) => setAlsm(value)} />
               <InputNumber addonBefore="Stations :" value={stations} style={{ width: "100%" }} onChange={(value) => setStations(value)} />
            </Space>
         </Modal>
      </>
   );
};
